// CANONICAL COPY (GH #7115). src/constants/obligations/obl-patch-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-patch-management',
  title: 'Review patch management status',
  description:
    'Review operating system and application patch levels. Verify automated patching is functioning and exceptions are documented. Auto-evaluated against the live Defender finding budget — passes when no P1 findings and ≤5 P2 findings remain open.',
  category: 'technical',
  scfIds: ['SCF-OPS-004'],
  cadence: { frequency: '1m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Vulnerability and patch management policy is published',
    },
    {
      type: 'vulnerability-priority-controlled',
      maxOpenP1: 0,
      maxOpenP2: 5,
      description: 'Open vulnerability backlog is within budget (no P1, ≤5 P2)',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
